import React from 'react';
import { Grid, User, Scale, Clock, RefreshCw, CheckCircle2 } from 'lucide-react';

const SupportTabs = ({ activeTab, setActiveTab, counts, mobile = false, desktop = false }) => {
  const tabs = [
    { id: 'all', label: 'All', icon: Grid, color: '#FF660E' },
    { id: 'my', label: 'My Tickets', icon: User, color: '#10B981' },
    { id: 'involved', label: 'Disputes', icon: Scale, color: '#DC2626' },
    { id: 'open', label: 'Open', icon: Clock, color: '#3B82F6' },
    { id: 'in_progress', label: 'In Progress', icon: RefreshCw, color: '#8B5CF6' },
    { id: 'resolved', label: 'Resolved', icon: CheckCircle2, color: '#059669' },
  ];

  const getCount = (tabId) => {
    return counts[tabId] || 0;
  };

  // Mobile version with scrollable tabs
  if (mobile) {
    return (
      <div className="flex space-x-2 py-3 overflow-x-auto scrollbar-hide">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const count = getCount(tab.id);
          const Icon = tab.icon;
          
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-col items-center px-3 py-2 rounded-lg whitespace-nowrap transition-all min-w-[80px] ${
                isActive
                  ? 'bg-[#ff660e] shadow'
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              <Icon 
                size={16} 
                className={`${isActive ? 'text-white' : 'text-gray-500'}`}
              />
              <span className={`text-xs font-medium mt-1 ${
                isActive ? 'text-white font-semibold' : 'text-gray-600'
              }`}>
                {tab.label}
              </span>
              
              {count > 0 && (
                <span className={`mt-1 px-1.5 py-0.5 text-xs font-bold rounded-full ${
                  isActive 
                    ? 'bg-white text-[#ff660e]' 
                    : 'text-white bg-[#ff660e]'
                }`}>
                  {count > 99 ? '99+' : count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  // Desktop version with vertical tabs
  if (desktop) {
    return (
      <div className="space-y-1">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const count = getCount(tab.id);
          const Icon = tab.icon;
          
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center justify-between w-full px-4 py-3 rounded-xl text-left transition-all ${
                isActive
                  ? 'bg-gray-50 border-l-4 shadow-sm'
                  : 'hover:bg-gray-50'
              }`}
              style={isActive ? { 
                borderLeftColor: tab.color,
                borderLeftWidth: '4px'
              } : {}}
            >
              <div className="flex items-center gap-3">
                <Icon 
                  size={18} 
                  style={{ color: isActive ? tab.color : '#94A3B8' }}
                />
                <span className={`font-medium ${
                  isActive ? 'font-semibold' : 'font-normal'
                }`}
                style={{ color: isActive ? tab.color : '#64748B' }}
                >
                  {tab.label}
                </span>
              </div>
              
              {count > 0 && (
                <span className={`px-2 py-1 text-xs font-bold rounded-full ${
                  isActive 
                    ? 'text-white' 
                    : 'text-gray-600 bg-gray-200'
                }`}
                style={isActive ? { backgroundColor: tab.color } : {}}
                >
                  {count > 99 ? '99+' : count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  // Default version (original horizontal tabs)
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex space-x-1 py-3 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            const count = getCount(tab.id);
            const Icon = tab.icon;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg whitespace-nowrap transition-all ${
                  isActive
                    ? 'bg-white shadow border shadow-gray-100'
                    : 'bg-gray-50 hover:bg-gray-100'
                }`}
                style={isActive ? { borderColor: tab.color, borderWidth: '1.5px' } : {}}
              >
                <Icon 
                  size={16} 
                  style={{ color: isActive ? tab.color : '#94A3B8' }}
                />
                <span className={`text-sm font-medium ${
                  isActive ? 'font-semibold' : 'font-normal'
                }`}
                style={{ color: isActive ? tab.color : '#64748B' }}
                >
                  {tab.label}
                </span>
                
                {count > 0 && (
                  <span className={`px-2 py-0.5 text-xs font-bold rounded-full ${
                    isActive 
                      ? 'text-white' 
                      : 'text-gray-600 bg-gray-200'
                  }`}
                  style={isActive ? { backgroundColor: tab.color } : {}}
                  >
                    {count > 99 ? '99+' : count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SupportTabs;